import { useTranslation } from 'react-i18next';
import { WidgetLoader } from 'datastake-daf/dist/components';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import useFetchHelper from '../../../../../helpers/useFetchHelper';
import RecTable from '../../../../../screens/Modules/pme/screens/dashboard/widgets/recTable';
import { filterEvent, getMeasureStatus } from '../../../../../screens/Modules/pme/screens/dashboard/widgets/recommendations';

export default function Recs({
  data,
  allEvents,
  project,
  language,
  organisationName,
}) {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [initialFetchIsDone, setInitialFetchIsDone] = useState(false);
  const ref = useRef();
  const { canFetch } = useFetchHelper({ ref });

  const _fetch = async () => {
    // setPage(1);

    if (!loaded) {
      setLoaded(true);
    }
  };

  useEffect(() => {
    if (canFetch) {
      // _fetch();
    }
  }, [language, canFetch]);

  const dataSource = useMemo(() => {
    if (data) {
      setInitialFetchIsDone(true);
      setTotal(data.metadata?.total || (data.records || []).length);
      return (data.records || []).map((d, i) => {
        const riskCategory = (data.options.riskCategory || []).find(opt =>
          opt.value === d.riskCategoryCamelCase
        );
        const riskType = (data.options.riskType || []).find(opt =>
          opt.value === d.riskTypeCamelCase
        );
        const responsibility = (d.linkedStakeholder || {}).name;

        return {
          key: i,
          ...d,
          riskType: riskType ? riskType.label : '-',
          responsibility,
          riskCategory: riskCategory ? riskCategory.label : '-',
          events: (d.events || []).map((e) => filterEvent(allEvents.find((ev) => ev.datastakeId === e), d.area)),
          status: getMeasureStatus(d),
        }
      });
    } else {
      setTotal(0);
      setInitialFetchIsDone(false);
    }
    return [];
  }, [data]);

  return (
    <div
      ref={ref}
      className='overflow-section-3'
    >
      {!data && <WidgetLoader background="white" />}
      <RecTable
        page={page}
        total={total}
        dataSource={dataSource}
        PmeDashboardGetWithFilters={_fetch}
        setPage={setPage}
        options={data ? data.options || {} : {}}
        initialFetchIsDone={initialFetchIsDone}
        t={t}
        isOwnData={false}
        isOverview={true}
        organisationName={organisationName}
        filters={{}}
        project={project}
        language={language}
        minHeight={450}
        maxHeight={450}
      />
    </div>
  )
}
